import { render, staticRenderFns } from "./BulkDeleteResultsModal.vue?vue&type=template&id=331dc470&"
import script from "./BulkDeleteResultsModal.vue?vue&type=script&lang=js&"
export * from "./BulkDeleteResultsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331dc470')) {
      api.createRecord('331dc470', component.options)
    } else {
      api.reload('331dc470', component.options)
    }
    module.hot.accept("./BulkDeleteResultsModal.vue?vue&type=template&id=331dc470&", function () {
      api.rerender('331dc470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/contacts/components/BulkDeleteResultsModal.vue"
export default component.exports